import { render, staticRenderFns } from "./BilancoRasyo.vue?vue&type=template&id=310a0bc0&scoped=true&"
import script from "./BilancoRasyo.vue?vue&type=script&lang=js&"
export * from "./BilancoRasyo.vue?vue&type=script&lang=js&"
import style0 from "./BilancoRasyo.vue?vue&type=style&index=0&id=310a0bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a0bc0",
  null
  
)

export default component.exports